/**
 * tm/consultRemind.ts — 동행상담 전날 팀장님 확인 연락(2026-10-28 지도사) · 서버 services/consultRemind
 *  sms = 지도사 이름 · 번호로 문자 발송 · copy = 누르는 사람 말투(직원이면 「지도사 사무실 ○○입니다」) — 자기 카톡으로 보내기용
 */
import { req } from './api';

export interface RemindTarget { key: string; role: 'FP' | 'WM' | string; name: string; honor: string; phone: string; why: string; sms: string; copy: string }
export interface RemindLog { at: string; by: string; via: 'sms' | 'copy' | string; results: { key: string; name: string; sent: boolean; error?: string }[] }
export interface RemindItem { id: string; company_name: string; date: string; time: string; location: string; status: string; targets: RemindTarget[]; remind: RemindLog | null }

export const remindList = (date?: string) => req<{ date: string; list: RemindItem[] }>('GET', `/consult-remind${date ? `?date=${encodeURIComponent(date)}` : ''}`);
export const remindSend = (id: string, body: { keys?: string[]; text?: string }) => req<{ remind: RemindLog }>('POST', `/consultations/${id}/remind/send`, body);
export const remindCopied = (id: string) => req<{ remind: RemindLog }>('POST', `/consultations/${id}/remind/copied`, {});

/** 담당 팀장님 먼저 · 없으면 첫 WM */
export const mainTarget = (it: RemindItem): RemindTarget | null => it.targets.find(t => t.key === 'fp') || it.targets[0] || null;

/** 지난 기록 한 줄 — 「17:30 문자 보냄 · 김민경 상무님」 · 「복사함(오재인)」 · 실패면 까닭 */
export function remindLine(r: RemindLog | null, targets: RemindTarget[]): { text: string; bad: boolean } | null {
  if (!r || !r.at) return null;
  const t = new Date(new Date(r.at).getTime() + 9 * 3600 * 1000).toISOString().slice(11, 16);
  if (r.via === 'copy') return { text: `${t} 복사함${r.by ? ` · ${r.by}` : ''}`, bad: false };
  const ok = r.results.filter(x => x.sent), bad = r.results.filter(x => !x.sent);
  const nameOf = (k: string, n: string) => (targets.find(x => x.key === k) || { honor: n }).honor;
  return {
    text: [ok.length ? `${t} 문자 보냄 · ${ok.map(x => nameOf(x.key, x.name)).join(', ')}` : '', bad.length ? `못 보냄 · ${bad.map(x => `${nameOf(x.key, x.name)}(${x.error || '실패'})`).join(', ')}` : ''].filter(Boolean).join(' · '),
    bad: !ok.length,
  };
}

/** 복사 — 안 되면 false(화면이 글을 보여 줘 길게 눌러 복사) */
export async function copyText(t: string): Promise<boolean> {
  try { if (navigator.clipboard && navigator.clipboard.writeText) { await navigator.clipboard.writeText(t); return true; } } catch { /* 아래 */ }
  return false;
}
/** 휴대폰 공유(카톡 고르기) — 없거나 막히면 false */
export async function shareText(t: string): Promise<boolean> {
  const nav = navigator as Navigator & { share?: (d: { text?: string }) => Promise<void> };
  if (!nav.share) return false;
  try { await nav.share({ text: t }); return true; } catch { return false; }
}
